import { render, staticRenderFns } from "./shiplist.vue?vue&type=template&id=20118c76&scoped=true&"
import script from "./shiplist.vue?vue&type=script&lang=js&"
export * from "./shiplist.vue?vue&type=script&lang=js&"
import style0 from "./shiplist.vue?vue&type=style&index=0&id=20118c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20118c76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VDivider,VToolbar,VToolbarTitle})
